import React, { useContext, useEffect, useState } from 'react'
import LeadsManagerTabs from './LeadsManagerTabs'
import Sitevisits from './LeadsFile/Sitevisits'
import Token from './LeadsFile/Token'
import Bookings from './LeadsFile/Bookings'
import Cancellation from './LeadsFile/Cancellation'
import '../LeadsManager/Leads.css'
import ScheduleSiteVisitModal from './Modal/ScheduleSiteVisitModal'
import { ReactComponent as ThreedotsIcon } from '../../assets/icons/threedots.svg';
import { getAllSitevisit, getUsers } from '../../services/private/plus.leads.service'
import Searchbox from '../../components/InputGroup/Searchbox'
import Timeline from './Modal/Timeline';
import Consumer from '../../helpers/context';
import PlusFilterModal from './Modal/PlusFilterModal'
import AppliedFiltersTag from './LeadsFile/AppliedFilterTag'

const LeadsManager = () => {
    const [selectedTab, setSelectedTab] = useState('Site_visit');
    const [showSitevisitModal, setShowSitevisitModal] = useState(false);
    const [leads, setLeads] = useState([]);
    const [leadsCount, setLeadsCount] = useState({});
    const [searchText, setSearchText] = useState('');
    const [selectedTmelineLead, setSelectedTimelineLead] = useState({});
    const [showTimeline, setShowTimeline] = useState(false);
    const [users, setUsers] = useState([]);
    const [filters, setFilters] = useState([]);
    const [showFilters, setShowFilters] = useState(false);

    const { userProfile } = useContext(Consumer)

    const getCompanyUsers = async () => {
        const res = await getUsers();
        if (res.data.status === 200) {
            const mappedUsers = res.data.data.users.map(i => ({ ...i, label: i.name, value: i.id }))
            setUsers(mappedUsers);
        }
    }

    const handleGetLeads = async () => {
        const payload = {
            filters: filters
        }
        try {
            const res = await getAllSitevisit(searchText, selectedTab, payload);
            if (res.data.status === 200) {
                setLeads(res.data.data?.entry);
                setLeadsCount(res.data.data?.stats)
            }
        } catch (err) {
            setLeads([]);
            setLeadsCount({})
        }
    }

    const removeFilterValue = (keyValue) => {
        let oldFilters = structuredClone(filters);
        delete oldFilters[keyValue]
        setFilters({ ...oldFilters });
    }

    useEffect(() => {
        handleGetLeads()
    }, [searchText, selectedTab, filters]);

    useEffect(() => {
        getCompanyUsers()
    }, [])

    return (
        <div className='!px-5 !py-4 !w-[calc(100%-69px)] '>
            <div>
                <h1 className='text-2xl font-semibold'>Leads</h1>
            </div>
            <div className='!mt-6 flex justify-between'>
                <div className=''>
                    <LeadsManagerTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} leadsCount={leadsCount} />
                </div>

               <div className="flex flex-wrap items-center justify-between space-y-4 sm:space-y-0 sm:space-x-4">
    {/* Search Box */}
    <div className="w-full sm:w-auto">
        <Searchbox 
            value={searchText} 
            onChange={(e) => setSearchText(e.target.value)} 
            handelClear={() => setSearchText('')} 
            placeholder="Search for Site visits" 
            classname="mr-0" 
        />
    </div>
    {/* Add Lead Button */}
    <button
        className="border rounded-lg text-white gradient-blue text-sm font-medium py-1.5 px-3 flex"
        onClick={() => setShowSitevisitModal(true)}
    >
        + Add Lead
    </button>
    {/* Filter Button (Visible only for owners) */}
    {userProfile?.is_owner && (
         <div className="filter-btn ">
         <button
           className={`d-flex align-items-center ${
             filters?.length > 0
               ? " border-0 pr-hover  active"
               : "border-0 btn"
           }`}
           type="button"
           onClick={() => setShowFilters(true)}
         >
           <svg
             className="mr-8"
             xmlns="http://www.w3.org/2000/svg"
             width="21"
             height="21"
             viewBox="0 0 21 21"
             fill="none"
           >
             <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M12.981 11.1747V15.5775C12.981 15.9053 12.7958 16.2049 12.5026 16.3515L9.04095 18.0823C8.46554 18.37 7.78852 17.9516 7.78852 17.3083V11.1747L1.92626 4.00973C1.46395 3.44468 1.86597 2.59631 2.59606 2.59631H18.1734C18.9035 2.59631 19.3056 3.44468 18.8432 4.00973L12.981 11.1747ZM11.2502 15.0426V10.8658C11.2502 10.666 11.3193 10.4724 11.4458 10.3178L16.3472 4.32713H4.42228L9.32372 10.3178C9.45022 10.4724 9.51934 10.666 9.51934 10.8658V15.908L11.2502 15.0426Z"
               fill="#696974"
             ></path>
           </svg>
           <span className="text-capitalize">
             Filter {filters?.length > 0 ? ` (${filters?.length})` : " "}
           </span>
         </button>
       </div>
    
    )}
    {/* More Options Dropdown */}
    <div className="dropdown view-more">
        <button className="bg-tr border-0 px-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <ThreedotsIcon />
        </button>
        <div className="dropdown-menu w-auto dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <div className="head-itme text-black700 text-xs font-medium">Actions</div>
            <a className="dropdown-item text-sm" onClick={() => setShowSitevisitModal(true)}>Schedule Site Visit</a>
        </div>
    </div>
</div>

            </div>
            {Object.keys(filters)?.length ? <AppliedFiltersTag filters={filters} removeFilterValue={removeFilterValue} /> : ''}
            <div className='!mt-6'>
                {selectedTab === 'Site_visit' && <Sitevisits
                    leads={leads}
                    handleGetLeads={handleGetLeads}
                    handleShowSitevisiModal={setShowSitevisitModal}
                    setSelectedTimelineLead={setSelectedTimelineLead}
                    setShowTimeline={setShowTimeline}
                    userProfile={userProfile}
                    users={users}
                />}
                {selectedTab === 'token' && <Token leads={leads} setSelectedTimelineLead={setSelectedTimelineLead} setShowTimeline={setShowTimeline} userProfile={userProfile} />}
                {selectedTab === 'booking' && <Bookings leads={leads} setSelectedTimelineLead={setSelectedTimelineLead} setShowTimeline={setShowTimeline} userProfile={userProfile} />}
                {selectedTab === 'cancel' && <Cancellation leads={leads} setSelectedTimelineLead={setSelectedTimelineLead} setShowTimeline={setShowTimeline} userProfile={userProfile} />}
            </div>

            {
                showSitevisitModal && <ScheduleSiteVisitModal
                    show={showSitevisitModal}
                    closeModal={() => setShowSitevisitModal(false)}
                    handleGetLeads={handleGetLeads}
                    users={users}
                    userProfile={userProfile}
                />
            }
            {
                showTimeline && <Timeline show={showTimeline} closeModal={() => setShowTimeline(false)} uuid={selectedTmelineLead?.site_visits[0].uuid} />
            }
            {
                showFilters && <PlusFilterModal
                    show={showFilters}
                    setShow={setShowFilters}
                    filtersData={filters}
                    setFiltersData={setFilters}
                    users={users}
                />
            }
        </div>
    )
}

export default LeadsManager